<template>
  <div>
    <EditorContent
      :editor="editor"
      class="mb-3"
    />
    <span class="text-muted">{{ creator }}, {{ timestamp | moment("ddd DD MMM [']YY HH:mm") }}</span>
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import {
  Bold,
  Italic,
  Strike,
  Underline,
  OrderedList,
  BulletList,
  ListItem
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent
  },
  props: {
    note: {
      type: Object,
      required: true
    },
    truncate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isTruncated: true,
      editor: undefined
    }
  },
  computed: {
    creator () {
      return this.$_.get(this.note, 'creator.name_full', 'Unknown User')
    },
    timestamp () {
      return new Date(this.note.created_at || this.note.updated_at)
    }
  },
  created () {
    this.editor = new Editor({
      extensions: [
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new OrderedList(),
        new BulletList(),
        new ListItem()
      ],
      content: this.note.content,
      editable: false
    })
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>
